module.exports = __webpack_public_path__ + "static/Logo_Textron_n-a63a0323b890ba1e161f1fc86ce48057.png";